export default "__VITE_ASSET__CcwGDOVK__"